import { Routes, RouterModule, CanActivate } from '@angular/router';
import { ModuleWithProviders } from '@angular/core/src/metadata';

import { HomeComponent } from './home/home.component';
import { AuthGuard } from './guards/auth.guard';
import { LoginComponent } from './login/login.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { VisualizarProvaComponent } from './dashboard/prova/visualizar-prova/visualizar-prova.component';
import { AcessoComponent } from './acesso/acesso.component';
import { ContratoComponent } from './contrato/contrato.component';
import { DeclaracaoComponent } from './declaracao/declaracao.component';
import { DeclaracaoViewComponent } from './declaracao/declaracao-view/declaracao-view.component';
import { DeclaracaoFinalComponent } from './declaracao/declaracao-view/declaracao-details/declaracao-final/declaracao-final.component';
import { OcorrenciaComponent } from './acesso/ocorrencia/ocorrencia.component';
import { CadastrarPaisagemComponent } from './cadastrar-paisagem/cadastrar-paisagem.component';
import { CadastrarAnimalComponent } from './cadastrar-animal/cadastrar-animal.component';
import { ControleSeapComponent } from './controle-seap/controle-seap.component';
import { AddCursoComponent } from './controle-seap/add-curso/add-curso.component';
import { ListaCursosComponent } from './controle-seap/lista-cursos/lista-cursos.component';
import { AddMatriculaComponent } from './controle-seap/add-matricula/add-matricula.component';
import { ListaMatriculasComponent } from './controle-seap/lista-matriculas/lista-matriculas.component';
import { ListaMatriculasConcluidasComponent } from './controle-seap/lista-matriculas-concluidas/lista-matriculas-concluidas.component';
import { DeclaracaoCqtComponent } from './declaracao-cqt/declaracao-cqt.component';
import { DeclaracaoViewCqtComponent } from './declaracao-cqt/declaracao-view/declaracao-view-cqt.component';
import { DeclaracaoFinalCqtComponent } from './declaracao-cqt/declaracao-view/declaracao-details/declaracao-final/declaracao-final-cqt.component';

export const ROUTES: Routes = [
  {
    path: '', component: ControleSeapComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'login', component: LoginComponent
  },
  {
    path: 'dashboard', component: DashboardComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'controle-seap', component: ControleSeapComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'controle-seap/add-curso', component: AddCursoComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'controle-seap/add-curso/:id', component: AddCursoComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'controle-seap/lista-cursos', component: ListaCursosComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'controle-seap/add-matricula', component: AddMatriculaComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'controle-seap/add-matricula/:id', component: AddMatriculaComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'controle-seap/lista-matriculas', component: ListaMatriculasComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'controle-seap/lista-matriculas-concluidas', component: ListaMatriculasConcluidasComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'controle-seap/lista-matriculas/:pendentes', component: ListaMatriculasComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'visualizar/:id', component: VisualizarProvaComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'acesso', component: AcessoComponent,
    // canActivate: [AuthGuard]
  },
  {
    path: 'contrato', component: ContratoComponent
  },
  {
    path: 'declaracao', component: DeclaracaoComponent
  },
  {
    path: 'declaracao-visualizar', component: DeclaracaoViewComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'declaracao-final/:id', component: DeclaracaoFinalComponent
  },
  {
    path: 'declaracao-cqt', component: DeclaracaoCqtComponent
  },
  {
    path: 'declaracao-visualizar-cqt', component: DeclaracaoViewCqtComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'declaracao-final-cqt/:id', component: DeclaracaoFinalCqtComponent
  },
  {
    path: 'ocorrencia', component: OcorrenciaComponent
  },
  {
    path: 'cadastrar-paisagem', component: CadastrarPaisagemComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'cadastrar-animal', component: CadastrarAnimalComponent,
    canActivate: [AuthGuard]
  },
];
